//CICD
export const environment = {
  production: true,
  baseAPIURL: '#{CONFIG.API_BASE_URL}',
  appURL: '#{CONFIG.APP_BASE_URL}',
  CALLBACK_PATH: 'implicit/callback',

  //okta settings
  ISSUER: '#{CONFIG.ISSUER}',
  CLIENT_ID: '#{CONFIG.CLIENT_ID}',
  SCOPES: 'email,openid',

  googleTagManagerId: '#{CONFIG.GOOGLE_TAG_MANAGER_ID}',

  debug: false
  
};

//dev settings
// export const environment = {
//   production: true,
//   baseAPIURL: 'https://nursing.dev.vizientinc.com/NRPDashboardAPI/',
//   appURL: 'https://nursing.dev.vizientinc.com/NRPDashboard/',
//   CALLBACK_PATH: 'implicit/callback',

//   // ISSUER:'https://dev-334334.okta.com/oauth2/default',
//   // SCOPES: 'email,openid',
//   // CLIENT_ID:'0oa53bjo1IDE0oAvE4x6',

//   ISSUER: 'https://sit-login.alliancewebs.net/oauth2/auslliad098ikdxec0h7',
//   CLIENT_ID: '0oaqnxoay53kVfVNL0h7',
//   SCOPES: 'email,openid',

//   debug: false
  
// };

//test settings
// export const environment = {
//   production: true,
//   baseAPIURL: 'https://nursing.test.vizientinc.com/NRPDashboardAPI/',
//   appURL: 'https://nursing.test.vizientinc.com/NRPDashboard/',
//   CALLBACK_PATH: 'implicit/callback',

//   ISSUER: 'https://sit-login.alliancewebs.net/oauth2/auslliad098ikdxec0h7',
//   CLIENT_ID: '0oaqnxoay53kVfVNL0h7',
//   SCOPES: 'email,openid',

//   debug: false
  
// };

//stage settings
// export const environment = {
//   production: true,
//   baseAPIURL: 'https://nursing.test.vizientinc.com/NRPDashboardAPI-Stage/',
//   appURL: 'https://nursing.test.vizientinc.com/NRPDashboard-Stage/',
//   CALLBACK_PATH: 'implicit/callback',

//   ISSUER: 'https://sit-login.alliancewebs.net/oauth2/auslliad098ikdxec0h7',
//   CLIENT_ID: '0oaqnxoay53kVfVNL0h7',
//   SCOPES: 'email,openid',

//   debug: false
  
// };

//prod settings
// export const environment = {
//   production: true,
//   baseAPIURL: 'https://nursing.vizientinc.com/NRPDashboardAPI/',
//   appURL: 'https://nursing.vizientinc.com/NRPDashboard/',
//   CALLBACK_PATH: 'implicit/callback',

//   ISSUER: 'https://login.alliancewebs.net/oauth2/ausmkot3jmgtQXrtZ0x7',
//   CLIENT_ID: '0oapix7x56NUieBit0x7',
//   SCOPES: 'email,openid',

//   debug: false
  
// };